import LoginLayout from "../../features/auth/layout/LoginLayout";
import NewAdminUserFormPresenter from "../../features/user/components/NewAdminUser/NewAdminUserForm/NewUserFormPresenter";
import useQueryURL from "../../common/hooks/useQueryURL";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

/**
 * NewAdminUserPage
 * 
 * @returns 
 */
export default function NewAdminUserPage() {
  const { getQueryValue } = useQueryURL();
  const tokenId = getQueryValue("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (!tokenId || tokenId === null) {
      navigate("/login");
    }
  }, [tokenId]); // eslint-disable-line

  return (
    <LoginLayout>
      <NewAdminUserFormPresenter withToken culkID={tokenId || "none"} />
    </LoginLayout>
  );
}
